import * as React from 'react'
import { useMutation } from '@apollo/react-hooks'
import { up } from 'styled-breakpoints'
import { css } from 'styled-components'

import { acceptAgreementsMutation } from '~/gql/mutations'
import type { ModalManagerProps } from '~/hooks/use-modal-manager'
import useVendor from '~/hooks/use-vendor'
import Anchor from '~/truck/anchor'
import Button from '~/truck/button'
import Label from '~/truck/label'
import notifier from '~/truck/notifier'
import theme from '~/truck/theme'
import type { IUser } from '~/types/users'
import { logout } from '~/utils'

import Modal from '../modal'

const buttonStyles = css`
  align-self: center;
  margin-top: ${theme.spacing.comfortable}px;

  ${up('lg')} {
    padding: 0 ${theme.spacing.comfortable}px;
    width: ${theme.spacing.cozy * 30}px;
  }
`

interface NeedsToAcceptTermsAndConditionsProps extends ModalManagerProps {
  user: IUser
}

const NeedsToAcceptTermsAndConditions = (props: NeedsToAcceptTermsAndConditionsProps) => {
  const { user, modalId } = props

  const vendor = useVendor()

  const [acceptAgreements, { loading }] = useMutation(acceptAgreementsMutation)

  const onAcceptTermsAndConditions = async () => {
    try {
      await acceptAgreements({
        variables: {
          acceptedTermsAndConditions: true,
        },
      })
    } catch (error) {
      console.error(error)

      notifier.error('Error al aceptar los términos y condiciones')
    }
  }

  return (
    <Modal style={{ overflowY: 'hidden' }}>
      <Modal.Header modalId={modalId} />
      <Label>
        Hola
        {` ${user.firstName || ''},`}
        <br />
        <br />
        En
        {` ${vendor.name} `}
        nos esforzamos en brindarte el mejor servicio. Por este motivo hemos actualizado y extendido nuestros
        <Anchor href={vendor.legalTermsUrl} target="_blank" $color="info">
          {' Términos y Condiciones'}
        </Anchor>
        .
        <br />
        <br />
        Al continuar usando nuestra tienda en línea, estás confirmando que has leído y estás de acuerdo con ellos.
      </Label>
      <Button onClick={onAcceptTermsAndConditions} loading={loading} color="secondary" css={buttonStyles}>
        Aceptar y Continuar
      </Button>
      <Button.Plain css={buttonStyles} onClick={() => logout()} color="error">
        Cerrar sesión
      </Button.Plain>
    </Modal>
  )
}

export default NeedsToAcceptTermsAndConditions
